// extracted by mini-css-extract-plugin
export default {"advertDetailHeader":"c-l_hj"};